<template>
	<div>
		<el-dialog title="发布" :visible.sync="dialogVisible" :center="true" :before-close="handleClose" width="80%"
			:append-to-body="true" height="80%">
			<div class="big">
				<div class="top" @click="ctop">111111111111</div>
				<div class="center">2222222222</div>
				<div class="bottom">33333333333333</div>
				<div class="footer">
					<ul>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "ReleasePlay",
		data() {
			return {
				dialogVisible: false,
			}
		},
		props: {
			deviceDialogVisible: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleClose() {
				// 子组件调用父组件方法，并传递参数
				this.$emit('changeShow', 'false')
			},
			ctop(){
				console.log('ctop')
			}
		},
		watch: {
			// 监听 addOrUpdateVisible 改变
			deviceDialogVisible() {
				this.dialogVisible = this.deviceDialogVisible
			},
		}
	}
</script>

<style lang="scss" scoped>
	ul{
		display: flex;
		justify-content: space-between;
		
	}
	ul li{
		background-image: url(../../../assets/images/home/logo.png);
	}
	$bgcolor : red;
	$bgcolory : green;

	@mixin important-text {
		color: red;
		font-size: 25px;
		font-weight: bold;
		border: 1px solid blue;
	}
	
	.footer{
		width: 300px;
		height: 100px;
		color: coral;
		background-color: pink;
	}
	
	.big {
		width: 100%;
		height: 300px;
		display: flex;

		div {
			border: 1px solid orchid;
			border-radius: 10px;


		}

		background-color: white;

		.top {
			height: 100px;
			width: 300px;
			background-color: $bgcolor;
		}

		.center {
			@include important-text;
			height: 100px;
			width: 300px;
			background-color: $bgcolory;

			&:hover {
				background-color: red;
			}
		}

		.bottom {
			@extend  .footer;
			margin: 10px auto;
			height: 50px;
			width: 150px;
			
			background-color: #35CAFA;
		}
	}
</style>
